import React from 'react';
import WestIcon from '@mui/icons-material/West';
import Heading from '../../component/Heading/Heading';
import { NavLink, useParams } from 'react-router';
import { resendVerifyEmail } from '../../services/authenticationService';
import Toast from '../../component/toastify/Index';
import logo from "../../assets/icons/logo.svg";
import AuthBg from '../../component/auth/AuthBg';
import "../../styles/pages/auth/signUp.scss"
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const CheckYouEmail = () => {
    const { email } = useParams();
    const { t } = useTranslation();
    const resendEmail = async () => {
        try {
            const response = await resendVerifyEmail(email)
            if (response?.isSuccess) {
                Toast(response?.message, "success");
            }
        } catch (error) {
            console.error("handleSubmit ~ error:", error);
        }
    }

    return (
        <div className="auth send-otp" >
            <div className="signup-container">
                <Grid container>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }} className='min-vh-100'>
                        <div className="logo-container">
                            <img src={logo} alt="logo" className='company-logo' />
                        </div>
                        <div className="signup-data">
                            <div className="input-container">
                                <div className='send-otp-data'>
                                    <Heading text={t('common_text_check_your_email')} />
                                    <p>{t("common_text_email_verification_link")}</p>
                                    <p className='send-mail'>{email}</p>
                                    <p className='not-recieve-email'>{t("common_text_don't_receive_the_email")} <span className='text-red resend' onClick={resendEmail}> {t("common_text_click_to_resend")} </span></p>

                                    <div className='flex Back-login-btn'>
                                        <p><WestIcon className='left-arrow-icon' /> </p>
                                        <p className='Back-login-data'><NavLink to="/signIn" className='text-black'>{t("common_text_back_to_login")}</NavLink></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6, lg: 8 }} className="signup-img-padding">
                        <AuthBg />
                    </Grid>
                </Grid>
            </div>
        </div >
    );
}

export default CheckYouEmail;
